import { memo } from 'react';
import { ConfirmDialog } from '@dfl/mui-admin-layout';
import { ListItemIcon, MenuItem, Typography } from '@mui/material';
import { EditIcon, DetailsIcon, TrashIcon } from 'components/SvgIcons';
import useRowAction from 'hooks/useRowAction';
import ActionTableMenu from 'modules/common/components/ActionTableMenu/ActionTableMenu';
import { useTranslation } from 'react-i18next';
import useClientMenuOptions from '../../hooks/useClientMenuOptions';

type UserStatusProps = {
  rowId: string;
};

const ClientRowActions = ({ rowId }: UserStatusProps) => {
  const { t } = useTranslation('common');

  const { handleEdit, handleDetails, handleConfirm, isLoading, error, isOpen, onClose, onOpen } =
    useClientMenuOptions(rowId);

  const { openTooltip, setOpenTooltip, handleAction } = useRowAction();

  return (
    <>
      <ConfirmDialog
        confirmButtonText={t('accept')}
        title={t('deleteConfirmation.title')}
        onConfirm={handleConfirm}
        confirmationMessage={t('deleteConfirmation.confirmation')}
        isLoading={isLoading}
        error={error}
        onClose={onClose}
        open={isOpen}
      />

      <ActionTableMenu onClose={handleAction} open={openTooltip} setOpenTooltip={setOpenTooltip}>
        <MenuItem
          onClick={() => {
            handleAction(handleEdit);
          }}
        >
          <ListItemIcon>
            <EditIcon />
          </ListItemIcon>
          <Typography color='secondary'>{t('edit')}</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleAction(handleDetails);
          }}
        >
          <ListItemIcon>
            <DetailsIcon />
          </ListItemIcon>
          <Typography color='secondary'>{t('viewDetails')}</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleAction(onOpen);
          }}
        >
          <ListItemIcon>
            <TrashIcon />
          </ListItemIcon>
          <Typography color='secondary'>{t('delete')}</Typography>
        </MenuItem>
      </ActionTableMenu>
    </>
  );
};

export default memo(ClientRowActions);
